import { Col, Row } from 'react-bootstrap';
import TextBlock from '@/components/atoms/text-block/text-block';
import LinkButton from '@/components/atoms/link-button/link-button';
import IAccommodation from '@/models/viewModels/IAccommodation';
import styles from './accommodation.module.scss';

type Props = {
  accommodation: IAccommodation;
};

export default function Accommodation({ accommodation }: Props) {
  return (
    <section id="university-accommodation" className="section-separator">
      <Row>
        <Col lg="8">
          <TextBlock title="Accommodation" text={accommodation.intro} titleSize={2} />
          {accommodation.url && (
            <div className={styles.accommodation_btn}>
              <LinkButton
                link={accommodation.url}
                text="University accommodation page"
                disclaimer
              />
            </div>
          )}
        </Col>
      </Row>
    </section>
  );
}
